import { PALETTE } from "../ui/tokens.ts";
import type { SilhouetteRule } from "./body.ts";

/**
 * The local character's silhouette through a building part (the author's ruling of 2026-10-03, ADR-040's amendment of
 * that day): building parts never fade, so while one hides the local character a flat-filled copy of its sprite draws
 * over the props, and the player never loses themselves.
 */

/**
 * Whether the silhouette shows: the building parts drawn above the local character hide, together, at least the
 * rule's share of its body box.
 *
 * @param keptCover The share of the body building parts hide together, in `[0, 1]`.
 * @param rule The silhouette's knobs.
 * @returns True when it shows.
 */
export function silhouetteShows(keptCover: number, rule: SilhouetteRule): boolean {
  return keptCover >= rule.coverage;
}

/**
 * The silhouette's fill colour as a 24-bit number, for a Phaser tint.
 *
 * @param rule The silhouette's knobs.
 * @returns The palette entry's value.
 */
export function silhouetteColour(rule: SilhouetteRule): number {
  return Number.parseInt(PALETTE[rule.colour].slice(1), 16);
}
